import { errorToast } from "@idwal/idwal-react-components";
import axios from 'axios';
import { getCurrentSessionIdToken } from "./amplify";
import { UserInfo } from "../types/UserInfo";

const getHeader = async () => {
    const token = await getCurrentSessionIdToken();

    return {
        "Content-Type": "application/json",
        "Authorization": 'Bearer ' + token
    }
}

export const getUserInfo = async (userId: string | undefined) => {
    if (userId) {     
        const url = process.env.REACT_APP_IDWAL_API_ENDPOINT + `/Users/${userId}/Info`;

        const headers = await getHeader();
        
        try {
            const response = await axios.get(url, { headers });
            
            const userInfo: UserInfo = response.data.data;

            return userInfo;
        } catch (error) {
            errorToast("Failed to get user info");
            return null;
        }
    }
    
    return null;
}

export const updateUserInfoAcknowledgement = async (userId: string | undefined) => {
    if (userId) {     
        const url = process.env.REACT_APP_IDWAL_API_ENDPOINT + `/Users/${userId}/Info`;

        const headers = await getHeader();

        const userInfo: UserInfo = {
            acknowledgement: true,
            acknowledgementAcceptedDate: `${Math.floor(Date.now() / 1000)}`,
        }
    
        try {
            await axios.post(url, JSON.stringify(userInfo), { headers });
        } catch (error) {
            errorToast("Failed to update user info");
        }
    }
}